import React, { useState, useEffect } from 'react';
import QrReader from 'react-qr-reader';
import jsqr from 'jsqr';
import { isMobile } from "react-device-detect";
import '../components/estilos.css';

const Lector = () => {

  const [qrCodeData, setQrCodeData] = useState(null);
  const [activate, setActivate] = useState(false);
  const [selected, setSelected] = useState('user');
  const [linternaEncendida, setLinternaEncendida] = useState(false);
  const [hasFlash, setHasFlash] = useState(false);
 
  useEffect(() => {
    const checkCameraFlash = async () => {
      if (isMobile) {
        if (selected === 'environment') {
          setHasFlash(true);
        } else { 
          setHasFlash(false);
          setLinternaEncendida(false)
        }
      } else {
        setHasFlash(false);
        setLinternaEncendida(false)
      }
    }; 
    checkCameraFlash();
  }, [selected]);

  const handleScan = (data) => {
    if (data) {
      setQrCodeData(data);
      setActivate(data.startsWith('http://') || data.startsWith('https://'));
    }
  }; 

  const handleError = (err) => {
    console.error(err);
  };

  const ventana = () => {
    window.open(qrCodeData);
  };
  
  const ventana2 = () => {
    window.open('https://qr.primerosauxilios.online/', '_top');
  };

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    const imageUrl = URL.createObjectURL(file);
    // Decodificar la imagen usando jsqr
    const qrCodeText = await decodeQRCode(imageUrl);
    setQrCodeData(qrCodeText);
    setActivate(qrCodeText.startsWith('http://') || qrCodeText.startsWith('https://'));
  };

  const decodeQRCode = async (imageUrl) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, img.width, img.height);
        const imageData = ctx.getImageData(0, 0, img.width, img.height);
        // Obtener el resultado del QR utilizando jsqr
        const code = jsqr(imageData.data, imageData.width, imageData.height);
        const qrCodeText = code ? code.data : '';
        resolve(qrCodeText);
      };
      img.onerror = (error) => {
        reject(error);
      };
      img.src = imageUrl;
    });
  };

  const toggleLinterna = async () => {
    if (selected === 'environment') {
      if (linternaEncendida) {
        console.log("apagado");
        turnOffFlashlight();
      } else {
        console.log("encendido");
        turnOnFlashlight();
      }
    }
  };

  const turnOnFlashlight = () => {
    if (isMobile) {
      try {
        navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
          .then(stream => {
            const track = stream.getVideoTracks()[0];
            track.applyConstraints({ advanced: [{ torch: true }] });
          })
          .catch(error => {
            console.log("No se pudo acceder a la linterna.", error);
          });
      } catch (error) {
        console.log("El navegador no admite la API de la linterna.", error);
      }
    } 
    setLinternaEncendida(true);
  };

  const turnOffFlashlight = () => {
    if (isMobile) {
      try {
        navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } })
          .then(stream => {
            const track = stream.getVideoTracks()[0];
            track.applyConstraints({ advanced: [{ torch: false }] });
          })
          .catch(error => {
            console.log("No se pudo apagar la linterna.", error);
          });
      } catch (error) {
        console.log("El navegador no admite la API de la linterna.", error);
      }
    }
    setLinternaEncendida(false);
  };

  return (
    <>
      <article className="card">
        <div className="select-styled">
          <select onChange={(e) => setSelected(e.target.value)}>
            <option value={'user'}>Cámara frontal</option>
            <option value={'environment'}>Cámara trasera</option>
          </select>
        </div> 

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <button
            style={{
              border: 'none',
              marginRight: '15px',
              cursor: hasFlash ? 'pointer' : 'not-allowed',
              width: '20%',
              borderRadius: '50%',
              padding: '10px',
              background: 'white',
            }} 
            onClick={toggleLinterna}
            disabled={!hasFlash}
          >
            {hasFlash ?(linternaEncendida ?
              <img
                src="https://s3.amazonaws.com/perfil.primerosauxilios.online/imgapp/71508.png"
                style={{ width: '60%', height: '50%' }}
                alt="Linterna encendida"
              />
             : 
              <img
                src="https://s3.amazonaws.com/perfil.primerosauxilios.online/imgapp/17664.png"
                style={{ width: '60%', height: '70%' }}
                alt="Linterna apagada"
              />
            )
            : 
            <img
              src="https://s3.amazonaws.com/perfil.primerosauxilios.online/imgapp/pngtree-no-camera-png-image_8427391.png"
              style={{ width: '74%', height: '70%' }}
              alt="Solo (Cámara trasera)"
            /> 
            } 
          </button>
          <span style={{ color: 'gray' }}>
            {hasFlash ? (linternaEncendida ? 'Linterna encendida' : 'Linterna apagada') : 'Linterna (Cámara trasera)'}
          </span>
        </div>
        <div className="qr-box" style={{ background: 'black', position: 'relative' }}>
          <div style={{ width: '300px', height: '300px' }}>
            <QrReader
              facingMode={selected}
              delay={1000}
              onError={handleError}
              onScan={handleScan}
              style={{ width: '100%' }}
            />
          </div>
          {qrCodeData && (
            <div
              style={{
                position: 'absolute',
                bottom: '-1px',
                left: '50%',
                transform: 'translateX(-50%)',
                background: 'green',
                color: 'white',
                padding: '4px 8px',
              }}
            >
              Código escaneado
            </div>
          )}
        </div>
        <p>
          Resultado del QR:{' '}
          <strong style={{ color: 'orange' }}>{qrCodeData}</strong>
        </p>

        <input type="file" style={{ cursor: 'pointer' }} accept="image/*" onChange={handleImageUpload} />

        {activate ? (
          <button
            onClick={ventana}
            style={{ cursor: 'pointer', background: 'black', color: 'white' }}
          >
            Abrir
          </button>
        ) : (
          <button disabled style={{ background: 'red', color: 'white' }}>
            Esperando Link
          </button>
        )}
      </article>
      <br />
    </>
  );
}

export default Lector;
